class CartRecommendationsSidebar extends HTMLElement {

    constructor() {
        super();
        this.generateRecommendations();
    }

    generateRecommendations() {
        document.addEventListener('rebuy:smartcart.show', (event) => {
            const SmartCart = window.Rebuy.SmartCart;
            const SmartCartItems = SmartCart.items();
            const SmartCartEl = document.querySelector("#rebuy-cart .rebuy-cart__flyout")

            if (SmartCartItems.length > 0) {
                fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${SmartCartItems[0].product.id}&limit=${this.dataset.limit}`)
                    .then(response => response.text())
                    .then(text => {
                        const innerHTML = new DOMParser()
                            .parseFromString(text, 'text/html')
                            .querySelector('[data-js-cart-recommendations-performed]');
                        if (innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0) {
                            this.innerHTML = innerHTML.innerHTML;
                            SmartCartEl.append(this);
                        }

                        const producItems = innerHTML.querySelectorAll(".product-item");

                        producItems.forEach(e => {
                            if(!document.querySelector(`#${e.dataset.id}`)) {
                                document.querySelector('body').append(e.querySelector('template').content);
                            }
                        })

                        document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
                            if (elm.hasAttribute('aria-controls')) {
                                const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
                                elm.addEventListener('click', e => {
                                    e.preventDefault();
                                    elm.setAttribute('aria-expanded', 'true');
                                    elmSidebar.show();
                                })
                                elm.addEventListener('keyup', e => {
                                    if (e.keyCode == window.KEYCODES.RETURN) {
                                        elm.setAttribute('aria-expanded', 'true');
                                        elmSidebar.show();
                                        elmSidebar.querySelector('[data-js-close]').focus();
                                    }
                                })
                            }
                        });

                        document.querySelector('.site-overlay').addEventListener('click', () => {
                            if (document.querySelector('.sidebar--opened')) {
                                document.querySelector('.sidebar--opened').hide();
                            }
                        });
                    })

            }
        });
    }
}
customElements.define('cart-recommendations-sidebar', CartRecommendationsSidebar);